module.exports = __webpack_public_path__ + "img/switzerland-lung-cancer-male.15221d5f.png";